var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"events-calendar-app"}},[_c('v-calendar',{attrs:{"attributes":_vm.attrs,"min-date":_vm.fromDate,"max-date":_vm.toDate,"color":"orange"},on:{"dayclick":_vm.handleDayClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }